// A boat's bottom paint in words: brand and product plus color ("Seahawk Cukote, Black"). The type (hard,
// ablative) doesn't tell anyone which can to pick up, so it's never the name. Pure: tests/unit/workRuns.test.mjs.
import { workKindOf } from './workRunCore.js';

const clean = v => String(v ?? '').trim();

/** "Seahawk Cukote, Black", or '' with no product on file. */
export function paintName(boat) {
  const product = clean(boat?.Bottom_Paint_Product);
  if (!product) return '';
  const color = clean(boat?.Bottom_Paint_Color);
  return color ? `${product}, ${color}` : product;
}

/** For a screen: the name, or says the product is missing. */
export function paintLine(boat, lang = 'EN') {
  const es = lang === 'ES';
  const name = paintName(boat);
  if (name) return name;
  const color = clean(boat?.Bottom_Paint_Color);
  const none = es ? 'Producto no registrado' : 'Product not on file';
  return color ? `${none}, ${color}` : (es ? 'Pintura no registrada' : 'Paint not on file');
}

export const isPaintOp = op => workKindOf(op) === 'paint';

const SWATCHES = { black: '#1B1F24', blue: '#1F5FA8', red: '#B8322A', green: '#2F7D32', white: '#FFFFFF', gray: '#7C8794', grey: '#7C8794' };
/** A CSS color for the can's color, when we know it. */
export const paintSwatch = boat => SWATCHES[clean(boat?.Bottom_Paint_Color).toLowerCase()] || '';
